export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8796.9c18f93d.jpg";